module.exports = __webpack_public_path__ + "static/lost-children-archive-10f60bb15a76903e72d7f14005aca891.jpg";